module.exports = __webpack_public_path__ + "static/img/2_3@2x.8dccbef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_3@2x.png
// module id = 8thV
// module chunks = 8